module.exports = __webpack_public_path__ + "img/esmeralda.3ecd255f.png";